import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { WorkerBillableItem } from "../_types/worker-billable-item";

@Injectable({
    providedIn: 'root',
})
export class WorkerBillableItemsService extends Service<WorkerBillableItem> {
    public override type = 'workerBillableItems';
    public override url = 'invoicing/workerBillableItems';
}
